// import React from "react";
// import SingleContentPage from "../Shared/SingleContentPage";

// const RecruitmentPortal = () => {
//   return <SingleContentPage title="Recruitment Portal" moduleKey="recruitment-portal" />;
// };

// export default RecruitmentPortal;
import React, { useState, useRef, useEffect } from "react";
import { recruitmentApi } from "../../config/api";
import { apiClient } from "../../utils/apiClient";
import "./RecruitmentPortal.scss";

// ─── Constants ────────────────────────────────────────────────────────────────
const DRIVE_STATUS_CONFIG = {
  Upcoming:   { color: "#1e40af", bg: "#eff6ff", border: "#bfdbfe", dot: "#3b82f6" },
  Ongoing:    { color: "#166534", bg: "#f0fdf4", border: "#bbf7d0", dot: "#22c55e" },
  Completed:  { color: "#475569", bg: "#f8fafc", border: "#e2e8f0", dot: "#94a3b8" },
  Cancelled:  { color: "#991b1b", bg: "#fef2f2", border: "#fecaca", dot: "#ef4444" },
  "On Hold":  { color: "#854d0e", bg: "#fefce8", border: "#fde68a", dot: "#f59e0b" },
};

const ROUND_TYPES = [
  "Aptitude Test", "Group Discussion", "Technical Interview",
  "HR Interview", "Coding Test", "Case Study", "Document Verification",
];

const COMPANY_SECTORS = [
  "Information Technology", "Banking & Finance", "Manufacturing",
  "Healthcare", "Education", "Consulting", "E-Commerce",
  "Government / PSU", "Media & Communication", "Other",
];

const DRIVE_MODES = ["On Campus", "Off Campus", "Virtual / Online", "Hybrid"];

const ELIGIBILITY_BRANCHES = [
  "All Branches", "Computer Science", "Mathematics", "Physics", "Chemistry",
  "Commerce", "Management", "English", "Economics", "Biology",
];

const TABS = [
  { key: "drives",    label: "Company Drives",     icon: "🏢" },
  { key: "companies", label: "Companies",           icon: "🏗️" },
  { key: "stats",     label: "Placement Stats",    icon: "📊" },
  { key: "settings",  label: "Portal Settings",    icon: "⚙️" },
];

const BLANK_DRIVE = {
  id: null,
  companyName: "", companyLogo: "", sector: "Information Technology",
  jobTitle: "", jobType: "Full Time", mode: "On Campus",
  packageMin: "", packageMax: "",
  driveDate: "", registrationDeadline: "", venue: "",
  eligibilityBranches: ["All Branches"], minCGPA: "6.0", backlogAllowed: false,
  rounds: [], description: "", status: "Upcoming",
  isPinned: false, isVisible: true,
  totalRegistered: 0, totalSelected: 0,
  tags: [],
};

const BLANK_COMPANY = {
  id: null, name: "", sector: "Information Technology", website: "",
  contactPerson: "", contactEmail: "", contactPhone: "",
  totalHires: 0, avgPackage: "", description: "", isMou: false,
};

// ─── Mapping Helpers ───
const mapBackendToFrontend = (d) => ({
  id: d._id,
  companyName: d.Company_Name || "",
  sector: d.Sector || "Information Technology",
  jobTitle: d.Job_Title_Role || "",
  jobType: d.Job_Type || "Full Time",
  packageMin: d.Package_Min_LPA || "",
  packageMax: d.Package_Max_LPA || "",
  driveDate: d.Drive_Date ? new Date(d.Drive_Date).toISOString().split('T')[0] : "",
  registrationDeadline: d.Registration_Deadline ? new Date(d.Registration_Deadline).toISOString().split('T')[0] : "",
  mode: d.Mode || "On Campus",
  venue: d.Venue_Link || "",
  description: d.Description || "",
  tags: d.Tags || [],
  status: d.Status || "Upcoming",
  isPinned: d.Pin_to_Top || false,
  isVisible: d.Visible_to_Students || false,
  totalRegistered: d.Total_Registered || 0,
  totalSelected: d.Total_Selected || 0,
  eligibilityBranches: d.Eligible_Branches || ["All Branches"],
  minCGPA: d.Minimum_CGPA || "6.0",
  backlogAllowed: d.Backlog_Allowed || false,
  rounds: d.Selection_Rounds || [],
});

const mapFrontendToBackend = (f) => ({
  Company_Name: f.companyName,
  Sector: f.sector,
  Job_Title_Role: f.jobTitle,
  Job_Type: f.jobType,
  Package_Min_LPA: parseFloat(f.packageMin) || 0,
  Package_Max_LPA: parseFloat(f.packageMax) || 0,
  Drive_Date: f.driveDate,
  Registration_Deadline: f.registrationDeadline,
  Mode: f.mode,
  Venue_Link: f.venue,
  Description: f.description,
  Tags: f.tags,
  Status: f.status,
  Pin_to_Top: f.isPinned,
  Visible_to_Students: f.isVisible,
  Total_Registered: parseInt(f.totalRegistered) || 0,
  Total_Selected: parseInt(f.totalSelected) || 0,
  Eligible_Branches: f.eligibilityBranches,
  Minimum_CGPA: parseFloat(f.minCGPA) || 0,
  Backlog_Allowed: f.backlogAllowed,
  Selection_Rounds: f.rounds,
});

const INITIAL_COMPANIES = [
  { id: 1, name: "Infosys Limited",   sector: "Information Technology", website: "https://infosys.com",  contactPerson: "Kavya Nair",    contactEmail: "campus@infosys.com",  contactPhone: "+91 80001 11111", totalHires: 24, avgPackage: "₹4.5 LPA", description: "Global IT services leader with 300,000+ employees.",      isMou: true  },
  { id: 2, name: "TCS",               sector: "Information Technology", website: "https://tcs.com",       contactPerson: "Rohan Sharma",   contactEmail: "campus@tcs.com",      contactPhone: "+91 80002 22222", totalHires: 31, avgPackage: "₹3.36 LPA", description: "India's largest IT company by revenue.",                   isMou: true  },
  { id: 3, name: "HDFC Bank",         sector: "Banking & Finance",      website: "https://hdfcbank.com",  contactPerson: "Priya Mehta",    contactEmail: "hr@hdfcbank.com",     contactPhone: "+91 80003 33333", totalHires: 8,  avgPackage: "₹5 LPA",   description: "India's largest private sector bank by assets.",           isMou: false },
  { id: 4, name: "Wipro Technologies",sector: "Information Technology", website: "https://wipro.com",     contactPerson: "Suresh Babu",    contactEmail: "campus@wipro.com",    contactPhone: "+91 80004 44444", totalHires: 18, avgPackage: "₹3.7 LPA", description: "Global IT, consulting, and business process services.",    isMou: true  },
  { id: 5, name: "Deloitte India",    sector: "Consulting",             website: "https://deloitte.com",  contactPerson: "Ananya Rao",     contactEmail: "campus@deloitte.com", contactPhone: "+91 80005 55555", totalHires: 5,  avgPackage: "₹8.5 LPA", description: "One of the Big Four professional services networks.",       isMou: false },
];

const INITIAL_STATS = {
  batch: "2024–25",
  totalStudentsEligible: 320, totalStudentsRegistered: 248,
  totalPlaced: 156, totalCompanies: 28, totalOffers: 172,
  highestPackage: "₹24 LPA", averagePackage: "₹5.2 LPA", medianPackage: "₹4.5 LPA",
  placementPercentage: "62.5%",
  departmentStats: [
    { dept: "Computer Science", eligible: 85, placed: 72, highest: "₹24 LPA", avg: "₹7.1 LPA" },
    { dept: "Mathematics",      eligible: 60, placed: 44, highest: "₹12 LPA", avg: "₹5.4 LPA" },
    { dept: "Commerce",         eligible: 70, placed: 38, highest: "₹9 LPA",  avg: "₹4.8 LPA" },
    { dept: "Management",       eligible: 55, placed: 42, highest: "₹18 LPA", avg: "₹6.2 LPA" },
  ],
};

const INITIAL_SETTINGS = {
  portalTitle: "Campus Recruitment Portal",
  portalSubtitle: "Connecting talent with opportunity — Class of 2025",
  placementOfficerName: "Dr. Anand Kumar",
  placementOfficerEmail: "placement@college.edu",
  placementOfficerPhone: "+91 98765 12345",
  registrationOpen: true,
  showPackageDetails: true,
  showCompanyContacts: false,
  portalMessage: "Placement season 2024–25 is officially open. Students must register via this portal and ensure all documents are updated before applying for drives.",
};

// ─── Main Component ───────────────────────────────────────────────────────────
const RecruitmentPortal = () => {
  const [activeTab, setActiveTab]         = useState("drives");
  const [drives, setDrives]               = useState([]);
  const [loading, setLoading]             = useState(false);
  const [companies, setCompanies]         = useState(INITIAL_COMPANIES);
  const [stats, setStats]                 = useState(INITIAL_STATS);
  const [settings, setSettings]           = useState(INITIAL_SETTINGS);
  const [settingsForm, setSettingsForm]   = useState(INITIAL_SETTINGS);

  // Drive states
  const [driveSearch, setDriveSearch]     = useState("");
  const [driveFilter, setDriveFilter]     = useState("all");
  const [driveSector, setDriveSector]     = useState("all");
  const [driveModal, setDriveModal]       = useState("");  // "add" | "edit" | "view"
  const [driveForm, setDriveForm]         = useState(BLANK_DRIVE);
  const [viewDrive, setViewDrive]         = useState(null);
  const [driveFormTab, setDriveFormTab]   = useState("basic");
  const [tagInput, setTagInput]           = useState("");
  const [roundInput, setRoundInput]       = useState("");

  // Company states
  const [companySearch, setCompanySearch] = useState("");
  const [companyModal, setCompanyModal]   = useState("");
  const [companyForm, setCompanyForm]     = useState(BLANK_COMPANY);

  // Stats edit
  const [statsModal, setStatsModal]       = useState(false);
  const [statsForm, setStatsForm]         = useState(INITIAL_STATS);

  // Settings edit
  const [settingsModal, setSettingsModal] = useState(false);

  // Shared
  const [confirm, setConfirm]             = useState({ type: "", id: null });
  const [dropdown, setDropdown]           = useState({ type: "", id: null, top: 0, left: 0 });
  const dropdownRef                       = useRef(null);

  useEffect(() => {
    fetchDrives();
    const onOut    = (e) => { if (dropdownRef.current && !dropdownRef.current.contains(e.target)) closeDD(); };
    const onScroll = () => closeDD();
    document.addEventListener("mousedown", onOut);
    window.addEventListener("scroll", onScroll, true);
    return () => { document.removeEventListener("mousedown", onOut); window.removeEventListener("scroll", onScroll, true); };
  }, []);

  const fetchDrives = async () => {
    try {
      setLoading(true);
      const res = await apiClient(recruitmentApi);
      const json = await res.json();
      if (res.ok) {
        setDrives((json.data || []).map(mapBackendToFrontend));
      }
    } catch (err) {
      console.error("Error fetching drives:", err);
    } finally {
      setLoading(false);
    }
  };

  const openDD  = (e, type, id) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    let left = rect.right - 230;
    if (left < 8) left = 8;
    setDropdown({ type, id, top: rect.bottom + 8, left });
  };
  const closeDD = () => setDropdown({ type: "", id: null, top: 0, left: 0 });

  // ── Drive helpers ──
  const openAddDrive  = () => { setDriveForm({ ...BLANK_DRIVE, driveDate: "", registrationDeadline: "" }); setTagInput(""); setRoundInput(""); setDriveFormTab("basic"); setDriveModal("add"); };
  const openEditDrive = (item) => { setDriveForm({ ...item, tags: [...item.tags], rounds: [...item.rounds], eligibilityBranches: [...item.eligibilityBranches] }); setTagInput(""); setRoundInput(""); setDriveFormTab("basic"); setDriveModal("edit"); closeDD(); };
  const openViewDrive = (item) => { setViewDrive(item); setDriveModal("view"); closeDD(); };

  const saveDrive = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const isAdd = driveModal === "add";
      const method = isAdd ? "POST" : "PUT";
      const url = isAdd ? recruitmentApi : `${recruitmentApi}/${driveForm.id}`;
      const payload = mapFrontendToBackend(driveForm);
      
      const res = await apiClient(url, {
        method,
        body: JSON.stringify(payload)
      });
      
      if (res.ok) {
        fetchDrives();
        setDriveModal("");
        setDriveForm(BLANK_DRIVE);
      }
    } catch (err) {
      console.error("Error saving drive:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    const { type, id } = confirm;
    if (type === "drive") {
      try {
        setLoading(true);
        const res = await apiClient(`${recruitmentApi}/${id}`, { method: "DELETE" });
        if (res.ok) fetchDrives();
      } catch (err) {
        console.error("Error deleting drive:", err);
      } finally {
        setLoading(false);
      }
    }
    if (type === "company") setCompanies((p) => p.filter((x) => x.id !== id));
    setConfirm({ type: "", id: null });
  };

  const toggleDrivePin     = async (id) => { 
    const item = drives.find(x => x.id === id);
    if (!item) return;
    try {
      const res = await apiClient(`${recruitmentApi}/${id}`, {
        method: "PUT",
        body: JSON.stringify({ Pin_to_Top: !item.isPinned })
      });
      if (res.ok) fetchDrives();
    } catch (err) { console.error(err); }
    closeDD(); 
  };
  const toggleDriveVisible = async (id) => { 
    const item = drives.find(x => x.id === id);
    if (!item) return;
    try {
      const res = await apiClient(`${recruitmentApi}/${id}`, {
        method: "PUT",
        body: JSON.stringify({ Visible_to_Students: !item.isVisible })
      });
      if (res.ok) fetchDrives();
    } catch (err) { console.error(err); }
    closeDD(); 
  };
  const setDriveStatus     = async (id, st) => { 
    try {
      const res = await apiClient(`${recruitmentApi}/${id}`, {
        method: "PUT",
        body: JSON.stringify({ Status: st })
      });
      if (res.ok) fetchDrives();
    } catch (err) { console.error(err); }
  };

  const addTag = (e) => {
    if ((e.key === "Enter" || e.key === ",") && tagInput.trim()) {
      e.preventDefault();
      const t = tagInput.trim().replace(/,$/, "");
      if (t && !driveForm.tags.includes(t)) setDriveForm((f) => ({ ...f, tags: [...f.tags, t] }));
      setTagInput("");
    }
  };
  const removeTag   = (t)  => setDriveForm((f) => ({ ...f, tags: f.tags.filter((x) => x !== t) }));
  const addRound    = (r)  => { if (r && !driveForm.rounds.includes(r)) setDriveForm((f) => ({ ...f, rounds: [...f.rounds, r] })); };
  const removeRound = (r)  => setDriveForm((f) => ({ ...f, rounds: f.rounds.filter((x) => x !== r) }));

  const toggleBranch = (b) => {
    const cur = driveForm.eligibilityBranches;
    if (b === "All Branches") { setDriveForm((f) => ({ ...f, eligibilityBranches: ["All Branches"] })); return; }
    const without = cur.filter((x) => x !== "All Branches" && x !== b);
    const hasIt   = cur.includes(b);
    setDriveForm((f) => ({ ...f, eligibilityBranches: hasIt ? (without.length ? without : ["All Branches"]) : [...without, b] }));
  };

  // ── Company helpers ──
  const openAddCompany  = () => { setCompanyForm({ ...BLANK_COMPANY }); setCompanyModal("add"); };
  const openEditCompany = (item) => { setCompanyForm({ ...item }); setCompanyModal("edit"); closeDD(); };
  const saveCompany = (e) => {
    e.preventDefault();
    if (companyModal === "add") setCompanies((p) => [{ ...companyForm, id: Date.now() }, ...p]);
    else setCompanies((p) => p.map((x) => x.id === companyForm.id ? { ...companyForm } : x));
    setCompanyModal(""); setCompanyForm(BLANK_COMPANY);
  };



  // ── Stats save ──
  const saveStats = (e) => {
    e.preventDefault();
    setStats({ ...statsForm });
    setStatsModal(false);
  };

  // ── Settings save ──
  const saveSettings = (e) => {
    e.preventDefault();
    setSettings({ ...settingsForm });
    setSettingsModal(false);
  };

  // ── Filtered drives ──
  const filteredDrives = drives.filter((d) => {
    const ms = !driveSearch || d.companyName.toLowerCase().includes(driveSearch.toLowerCase())
      || d.jobTitle.toLowerCase().includes(driveSearch.toLowerCase())
      || d.tags.some((t) => t.toLowerCase().includes(driveSearch.toLowerCase()));
    const mst = driveFilter === "all" || d.status === driveFilter;
    const msc = driveSector === "all" || d.sector === driveSector;
    return ms && mst && msc;
  });

  const pinnedDrives  = filteredDrives.filter((d) => d.isPinned);
  const regularDrives = filteredDrives.filter((d) => !d.isPinned);

  const filteredCompanies = companies.filter((c) =>
    !companySearch || c.name.toLowerCase().includes(companySearch.toLowerCase())
      || c.sector.toLowerCase().includes(companySearch.toLowerCase())
  );

  const formatDate  = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
  const daysLeft    = (d) => d ? Math.ceil((new Date(d) - new Date()) / (1000 * 60 * 60 * 24)) : null;
  const isExpired   = (d) => d && new Date(d) < new Date();
  const sc          = (status) => DRIVE_STATUS_CONFIG[status] || DRIVE_STATUS_CONFIG["Upcoming"];

  const summaryStats = [
    { icon: "🏢", label: "Total Drives",      value: drives.length,                                 color: "#7c3aed" },
    { icon: "🟢", label: "Upcoming",          value: drives.filter((d) => d.status === "Upcoming").length,  color: "#2563eb" },
    { icon: "⚡", label: "Ongoing",           value: drives.filter((d) => d.status === "Ongoing").length,   color: "#059669" },
    { icon: "✅", label: "Completed",         value: drives.filter((d) => d.status === "Completed").length, color: "#475569" },
    { icon: "🎓", label: "Total Selected",    value: drives.reduce((a, d) => a + (d.totalSelected || 0), 0), color: "#0891b2" },
    { icon: "📝", label: "Registered",        value: drives.reduce((a, d) => a + (d.totalRegistered || 0), 0), color: "#d97706" },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="rp-page">

      {/* ── Loading Overlay ── */}
      {loading && (
        <div className="rp-loading-overlay">
          <div className="rp-spinner" />
          <p>Syncing with database...</p>
        </div>
      )}

      {/* ── Header ── */}
      <div className="rp-header">
        <div className="rp-header-left">
          <div className="rp-header-icon">🎓</div>
          <div>
            <div className="rp-breadcrumb">
              <span>Careers</span>
              <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
              <span className="rp-bc-active">Recruitment Portal</span>
            </div>
            <h1>Recruitment Portal</h1>
            <p>Manage campus drives, company profiles, placement statistics, and portal settings.</p>
          </div>
        </div>
        <div className="rp-header-actions">
          {activeTab === "drives"    && <button className="rp-btn-primary" onClick={openAddDrive}>+ Add Drive</button>}
          {activeTab === "companies" && <button className="rp-btn-primary" onClick={openAddCompany}>+ Add Company</button>}
          {activeTab === "stats"     && <button className="rp-btn-secondary" onClick={() => { setStatsForm({ ...stats }); setStatsModal(true); }}>✏️ Edit Stats</button>}
          {activeTab === "settings"  && <button className="rp-btn-secondary" onClick={() => { setSettingsForm({ ...settings }); setSettingsModal(true); }}>✏️ Edit Settings</button>}
        </div>
      </div>

      {/* ── Summary Stats ── */}
      <div className="rp-stats-row">
        {summaryStats.map((s) => (
          <div className="rp-stat-card" key={s.label} style={{ borderTopColor: s.color }}>
            <span className="rp-stat-icon">{s.icon}</span>
            <div>
              <strong style={{ color: s.color }}>{s.value}</strong>
              <p>{s.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* ── Tabs ── */}
      <div className="rp-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            className={`rp-tab ${activeTab === t.key ? "active" : ""}`}
            onClick={() => setActiveTab(t.key)}
          >
            <span>{t.icon}</span> {t.label}
          </button>
        ))}
      </div>

      {/* ══════════════════════ DRIVES TAB ══════════════════════ */}
      {activeTab === "drives" && (
        <div className="rp-tab-content">
          {/* Filters */}
          <div className="rp-filters">
            <div className="rp-search">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              <input
                type="text" placeholder="Search company, role, or tag..."
                value={driveSearch} onChange={(e) => setDriveSearch(e.target.value)}
              />
              {driveSearch && <button className="rp-clr" onClick={() => setDriveSearch("")}>×</button>}
            </div>
            <select className="rp-select" value={driveFilter}  onChange={(e) => setDriveFilter(e.target.value)}>
              <option value="all">All Statuses</option>
              {Object.keys(DRIVE_STATUS_CONFIG).map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
            <select className="rp-select" value={driveSector} onChange={(e) => setDriveSector(e.target.value)}>
              <option value="all">All Sectors</option>
              {COMPANY_SECTORS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          {/* Pinned */}
          {pinnedDrives.length > 0 && (
            <div className="rp-pinned-section">
              <div className="rp-section-label"><span>📌</span> Pinned Drives</div>
              <div className="rp-drives-grid">
                {pinnedDrives.map((d) => (
                  <DriveCard key={d.id} item={d} sc={sc} formatDate={formatDate}
                    isExpired={isExpired} daysLeft={daysLeft}
                    openView={openViewDrive} openDD={openDD}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Regular */}
          {regularDrives.length > 0
            ? <div className="rp-drives-grid">
                {regularDrives.map((d) => (
                  <DriveCard key={d.id} item={d} sc={sc} formatDate={formatDate}
                    isExpired={isExpired} daysLeft={daysLeft}
                    openView={openViewDrive} openDD={openDD}
                  />
                ))}
              </div>
            : !loading && filteredDrives.length === 0 && (
              <div className="rp-empty">
                <div>🏢</div>
                <h3>No drives found</h3>
                <p>{driveSearch ? "Try a different search." : "Add your first campus drive."}</p>
                {!driveSearch && <button className="rp-btn-primary" onClick={openAddDrive}>+ Add Drive</button>}
              </div>
            )
          }
        </div>
      )}

      {/* ══════════════════════ COMPANIES TAB ══════════════════════ */}
      {activeTab === "companies" && (
        <div className="rp-tab-content">
          <div className="rp-filters">
            <div className="rp-search">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              <input
                type="text" placeholder="Search companies..."
                value={companySearch} onChange={(e) => setCompanySearch(e.target.value)}
              />
              {companySearch && <button className="rp-clr" onClick={() => setCompanySearch("")}>×</button>}
            </div>
          </div>

          <div className="rp-companies-grid">
            {filteredCompanies.map((c) => (
              <div className="rp-company-card" key={c.id}>
                <div className="rp-company-head">
                  <div className="rp-company-avatar">
                    {c.name.charAt(0).toUpperCase()}
                  </div>
                  <div className="rp-company-title">
                    <h3>{c.name}</h3>
                    <span className="rp-sector-pill">{c.sector}</span>
                    {c.isMou && <span className="rp-mou-badge">🤝 MoU</span>}
                  </div>
                  <button className="rp-dots" onClick={(e) => openDD(e, "company", c.id)}>⋮</button>
                </div>

                {c.description && <p className="rp-company-desc">{c.description}</p>}

                <div className="rp-company-info">
                  {[
                    { icon: "👤", val: c.contactPerson },
                    { icon: "✉️", val: c.contactEmail  },
                    { icon: "📞", val: c.contactPhone   },
                    { icon: "🌐", val: c.website        },
                  ].filter((x) => x.val).map((x, i) => (
                    <div key={i} className="rp-company-info-row">
                      <span>{x.icon}</span><p>{x.val}</p>
                    </div>
                  ))}
                </div>

                <div className="rp-company-footer">
                  <div className="rp-company-stat">
                    <strong>{c.totalHires}</strong><span>Total Hired</span>
                  </div>
                  <div className="rp-company-stat">
                    <strong>{c.avgPackage || "—"}</strong><span>Avg. Package</span>
                  </div>
                </div>
              </div>
            ))}
            {filteredCompanies.length === 0 && (
              <div className="rp-empty">
                <div>🏗️</div>
                <h3>No companies found</h3>
                <p>Add your first company to the portal.</p>
                <button className="rp-btn-primary" onClick={openAddCompany}>+ Add Company</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ══════════════════════ STATS TAB ══════════════════════ */}
      {activeTab === "stats" && (
        <div className="rp-tab-content">
          <div className="rp-stats-banner">
            <div className="rp-stats-banner-head">
              <div>
                <h2>📊 Placement Statistics — {stats.batch}</h2>
                <p>Overall placement performance for the current academic batch.</p>
              </div>
            </div>

            <div className="rp-placement-kpis">
              {[
                { icon: "👥", label: "Eligible Students",    value: stats.totalStudentsEligible, color: "#7c3aed" },
                { icon: "📝", label: "Registered",           value: stats.totalStudentsRegistered, color: "#2563eb" },
                { icon: "🎓", label: "Total Placed",         value: stats.totalPlaced,            color: "#059669" },
                { icon: "🏢", label: "Companies Visited",    value: stats.totalCompanies,         color: "#0891b2" },
                { icon: "📋", label: "Total Offers",         value: stats.totalOffers,            color: "#d97706" },
                { icon: "📈", label: "Placement %",          value: stats.placementPercentage,    color: "#dc2626" },
              ].map((k) => (
                <div className="rp-kpi-card" key={k.label} style={{ borderTopColor: k.color }}>
                  <span className="rp-kpi-icon">{k.icon}</span>
                  <strong style={{ color: k.color }}>{k.value}</strong>
                  <p>{k.label}</p>
                </div>
              ))}
            </div>

            <div className="rp-package-row">
              {[
                { label: "Highest Package",  value: stats.highestPackage,  icon: "🏆" },
                { label: "Average Package",  value: stats.averagePackage,  icon: "📊" },
                { label: "Median Package",   value: stats.medianPackage,   icon: "📉" },
              ].map((p) => (
                <div className="rp-package-card" key={p.label}>
                  <span>{p.icon}</span>
                  <div>
                    <strong>{p.value}</strong>
                    <p>{p.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Department-wise */}
          <div className="rp-section-head">
            <h2>🏫 Department-wise Placement</h2>
          </div>
          <div className="rp-dept-stats-grid">
            {stats.departmentStats.map((d) => {
              const pct = Math.round((d.placed / d.eligible) * 100);
              return (
                <div className="rp-dept-stat-card" key={d.dept}>
                  <div className="rp-dept-stat-head">
                    <strong>{d.dept}</strong>
                    <span className="rp-pct-badge">{pct}%</span>
                  </div>
                  <div className="rp-dept-bar-wrap">
                    <div className="rp-dept-bar" style={{ width: `${pct}%` }}/>
                  </div>
                  <div className="rp-dept-stat-row">
                    <div><p>Eligible</p><strong>{d.eligible}</strong></div>
                    <div><p>Placed</p><strong>{d.placed}</strong></div>
                    <div><p>Highest</p><strong>{d.highest}</strong></div>
                    <div><p>Average</p><strong>{d.avg}</strong></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ══════════════════════ SETTINGS TAB ══════════════════════ */}
      {activeTab === "settings" && (
        <div className="rp-tab-content">
          <div className="rp-settings-grid">
            <div className="rp-settings-card">
              <h3>🏛️ Portal Identity</h3>
              <div className="rp-settings-list">
                <div><span>Title</span><strong>{settings.portalTitle}</strong></div>
                <div><span>Subtitle</span><strong>{settings.portalSubtitle}</strong></div>
                <div><span>Batch</span><strong>{stats.batch}</strong></div>
              </div>
            </div>
            <div className="rp-settings-card">
              <h3>👤 Placement Officer</h3>
              <div className="rp-settings-list">
                <div><span>Name</span><strong>{settings.placementOfficerName}</strong></div>
                <div><span>Email</span><strong>{settings.placementOfficerEmail}</strong></div>
                <div><span>Phone</span><strong>{settings.placementOfficerPhone}</strong></div>
              </div>
            </div>
            <div className="rp-settings-card">
              <h3>⚙️ Portal Controls</h3>
              <div className="rp-settings-list">
                <div>
                  <span>Student Registration</span>
                  <span className={`rp-toggle-status ${settings.registrationOpen ? "on" : "off"}`}>
                    {settings.registrationOpen ? "✅ Open" : "❌ Closed"}
                  </span>
                </div>
                <div>
                  <span>Show Package Details</span>
                  <span className={`rp-toggle-status ${settings.showPackageDetails ? "on" : "off"}`}>
                    {settings.showPackageDetails ? "✅ Yes" : "❌ No"}
                  </span>
                </div>
                <div>
                  <span>Show Company Contacts</span>
                  <span className={`rp-toggle-status ${settings.showCompanyContacts ? "on" : "off"}`}>
                    {settings.showCompanyContacts ? "✅ Visible" : "❌ Hidden"}
                  </span>
                </div>
              </div>
            </div>
            <div className="rp-settings-card full-width">
              <h3>📢 Portal Announcement</h3>
              <p className="rp-portal-message">"{settings.portalMessage}"</p>
            </div>
          </div>
        </div>
      )}

      {/* ══════ DROPDOWN ══════ */}
      {dropdown.id !== null && (
        <div
          ref={dropdownRef}
          className="rp-dropdown"
          style={{ position: "fixed", top: dropdown.top, left: dropdown.left, zIndex: 99999 }}
        >
          {dropdown.type === "drive" && (() => {
            const item = drives.find((x) => x.id === dropdown.id);
            if (!item) return null;
            return (<>
              <button onClick={() => openViewDrive(item)}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                </svg>
                View Details
              </button>
              <button onClick={() => openEditDrive(item)}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
                </svg>
                Edit
              </button>
              <button onClick={() => toggleDrivePin(item.id)}>
                <span style={{ fontSize: 14 }}>{item.isPinned ? "📌" : "📍"}</span>
                {item.isPinned ? "Unpin" : "Pin to Top"}
              </button>
              <button onClick={() => toggleDriveVisible(item.id)}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
                  {item.isVisible
                    ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>
                    : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>}
                </svg>
                {item.isVisible ? "Hide from Students" : "Show to Students"}
              </button>
              <div className="rp-dd-divider"/>
              <div className="rp-dd-label">Change Status</div>
              {Object.keys(DRIVE_STATUS_CONFIG).map((st) => (
                <button key={st} className={item.status === st ? "rp-dd-active" : ""} onClick={() => setDriveStatus(item.id, st)}>
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: DRIVE_STATUS_CONFIG[st].dot, display: "inline-block", flexShrink: 0 }}/>
                  {st} {item.status === st && "✓"}
                </button>
              ))}
              <div className="rp-dd-divider"/>
              <button className="rp-dd-del" onClick={() => { setConfirm({ type: "drive", id: item.id }); closeDD(); }}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
                  <path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/>
                </svg>
                Delete Drive
              </button>
            </>);
          })()}

          {dropdown.type === "company" && (() => {
            const item = companies.find((x) => x.id === dropdown.id);
            if (!item) return null;
            return (<>
              <button onClick={() => openEditCompany(item)}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
                </svg>
                Edit Company
              </button>
              <div className="rp-dd-divider"/>
              <button className="rp-dd-del" onClick={() => { setConfirm({ type: "company", id: item.id }); closeDD(); }}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
                  <path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/>
                </svg>
                Delete Company
              </button>
            </>);
          })()}
        </div>
      )}

      {/* ══════ DRIVE VIEW MODAL ══════ */}
      {driveModal === "view" && viewDrive && (
        <div className="rp-overlay" onClick={() => { setDriveModal(""); setViewDrive(null); }}>
          <div className="rp-view-modal" onClick={(e) => e.stopPropagation()}>
            <button className="rp-modal-close abs" onClick={() => { setDriveModal(""); setViewDrive(null); }}>×</button>

            <div className="rp-view-head">
              <div className="rp-view-company-avatar">{viewDrive.companyName.charAt(0)}</div>
              <div>
                <div className="rp-view-meta-row">
                  <span className="rp-sector-pill">{viewDrive.sector}</span>
                  <span className="rp-status-badge"
                    style={{ background: sc(viewDrive.status).bg, color: sc(viewDrive.status).color, border: `1px solid ${sc(viewDrive.status).border}` }}>
                    <span className="rp-status-dot" style={{ background: sc(viewDrive.status).dot }}/>
                    {viewDrive.status}
                  </span>
                  {viewDrive.isPinned    && <span className="rp-badge-sm pin">📌 Pinned</span>}
                  {!viewDrive.isVisible  && <span className="rp-badge-sm hidden">🙈 Hidden</span>}
                </div>
                <h2>{viewDrive.companyName}</h2>
                <p className="rp-view-job-title">{viewDrive.jobTitle} · {viewDrive.jobType} · {viewDrive.mode}</p>
              </div>
            </div>

            <div className="rp-view-body">
              {/* Package highlight */}
              {(viewDrive.packageMin || viewDrive.packageMax) && (
                <div className="rp-package-highlight">
                  <span>💰</span>
                  <div>
                    <strong>
                      {viewDrive.packageMin && viewDrive.packageMax && viewDrive.packageMin !== viewDrive.packageMax
                        ? `₹${viewDrive.packageMin} – ₹${viewDrive.packageMax} LPA`
                        : `₹${viewDrive.packageMin || viewDrive.packageMax} LPA`}
                    </strong>
                    <p>CTC / Package Offered</p>
                  </div>
                </div>
              )}

              {/* Drive details grid */}
              <div className="rp-view-details-grid">
                {[
                  { label: "Drive Date",            value: formatDate(viewDrive.driveDate) },
                  { label: "Registration Deadline", value: formatDate(viewDrive.registrationDeadline) },
                  { label: "Mode",                  value: viewDrive.mode },
                  { label: "Venue",                 value: viewDrive.venue || "TBD" },
                  { label: "Registered",            value: viewDrive.totalRegistered },
                  { label: "Selected",              value: viewDrive.totalSelected },
                  { label: "Min CGPA",              value: viewDrive.minCGPA || "No criteria" },
                  { label: "Backlog Allowed",       value: viewDrive.backlogAllowed ? "Yes" : "No" },
                ].map((d) => (
                  <div className="rp-detail-item" key={d.label}>
                    <span>{d.label}</span><strong>{d.value}</strong>
                  </div>
                ))}
              </div>

              {/* Eligible branches */}
              {viewDrive.eligibilityBranches.length > 0 && (
                <div className="rp-view-section">
                  <h4>🏫 Eligible Branches</h4>
                  <div className="rp-branch-pills">
                    {viewDrive.eligibilityBranches.map((b) => (
                      <span key={b} className="rp-branch-pill">{b}</span>
                    ))}
                  </div>
                </div>
              )}

              {/* Selection rounds */}
              {viewDrive.rounds.length > 0 && (
                <div className="rp-view-section">
                  <h4>🔄 Selection Rounds</h4>
                  <div className="rp-rounds-list">
                    {viewDrive.rounds.map((r, i) => (
                      <div key={i} className="rp-round-item">
                        <span className="rp-round-num">{i + 1}</span>
                        <span>{r}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {viewDrive.description && (
                <div className="rp-view-section">
                  <h4>📌 About This Drive</h4>
                  <p>{viewDrive.description}</p>
                </div>
              )}

              {viewDrive.tags.length > 0 && (
                <div className="rp-tag-row">
                  {viewDrive.tags.map((t) => <span key={t} className="rp-tag">#{t}</span>)}
                </div>
              )}

              <div className="rp-view-actions">
                <button className="rp-btn-secondary" onClick={() => { openEditDrive(viewDrive); setViewDrive(null); }}>✏️ Edit Drive</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════ DRIVE ADD/EDIT MODAL ══════ */}
      {(driveModal === "add" || driveModal === "edit") && (
        <div className="rp-overlay" onClick={() => setDriveModal("")}>
          <div className="rp-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="rp-modal-head">
              <div>
                <h2>{driveModal === "add" ? "Add Campus Drive" : "Edit Drive"}</h2>
                <p>{driveModal === "add" ? "Enter drive details to publish it for students." : "Update the drive information."}</p>
              </div>
              <button className="rp-modal-close" onClick={() => setDriveModal("")}>×</button>
            </div>

            <div className="rp-form-tabs">
              {[
                { key: "basic",       label: "Drive Info",     icon: "🏢" },
                { key: "eligibility", label: "Eligibility",    icon: "✅" },
                { key: "rounds",      label: "Rounds",         icon: "🔄" },
              ].map((t) => (
                <button key={t.key} type="button"
                  className={`rp-form-tab ${driveFormTab === t.key ? "active" : ""}`}
                  onClick={() => setDriveFormTab(t.key)}
                >
                  {t.icon} {t.label}
                </button>
              ))}
            </div>

            <form className="rp-form" onSubmit={saveDrive}>

              {/* ── Tab: Drive Info ── */}
              {driveFormTab === "basic" && (
                <div className="rp-form-section">
                  <div className="rp-field-row">
                    <div className="rp-field">
                      <label>Company Name <span className="req">*</span></label>
                      <input type="text" required value={driveForm.companyName}
                        onChange={(e) => setDriveForm({ ...driveForm, companyName: e.target.value })}
                        placeholder="e.g. Infosys Limited"
                      />
                    </div>
                    <div className="rp-field">
                      <label>Sector <span className="req">*</span></label>
                      <select value={driveForm.sector} onChange={(e) => setDriveForm({ ...driveForm, sector: e.target.value })}>
                        {COMPANY_SECTORS.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="rp-field-row">
                    <div className="rp-field">
                      <label>Job Title / Role <span className="req">*</span></label>
                      <input type="text" required value={driveForm.jobTitle}
                        onChange={(e) => setDriveForm({ ...driveForm, jobTitle: e.target.value })}
                        placeholder="e.g. Systems Engineer"
                      />
                    </div>
                    <div className="rp-field">
                      <label>Job Type</label>
                      <select value={driveForm.jobType} onChange={(e) => setDriveForm({ ...driveForm, jobType: e.target.value })}>
                        {["Full Time", "Internship", "Part Time", "Contract"].map((t) => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="rp-field-row">
                    <div className="rp-field">
                      <label>Package Min (LPA)</label>
                      <input type="text" value={driveForm.packageMin}
                        onChange={(e) => setDriveForm({ ...driveForm, packageMin: e.target.value })}
                        placeholder="e.g. 3.6"
                      />
                    </div>
                    <div className="rp-field">
                      <label>Package Max (LPA)</label>
                      <input type="text" value={driveForm.packageMax}
                        onChange={(e) => setDriveForm({ ...driveForm, packageMax: e.target.value })}
                        placeholder="e.g. 4.5"
                      />
                    </div>
                  </div>
                  <div className="rp-field-row">
                    <div className="rp-field">
                      <label>Drive Date <span className="req">*</span></label>
                      <input type="date" required value={driveForm.driveDate} onChange={(e) => setDriveForm({ ...driveForm, driveDate: e.target.value })} />
                    </div>
                    <div className="rp-field">
                      <label>Registration Deadline <span className="req">*</span></label>
                      <input type="date" required value={driveForm.registrationDeadline} onChange={(e) => setDriveForm({ ...driveForm, registrationDeadline: e.target.value })} />
                    </div>
                  </div>
                  <div className="rp-field-row">
                    <div className="rp-field">
                      <label>Mode</label>
                      <select value={driveForm.mode} onChange={(e) => setDriveForm({ ...driveForm, mode: e.target.value })}>
                        {DRIVE_MODES.map((m) => <option key={m} value={m}>{m}</option>)}
                      </select>
                    </div>
                    <div className="rp-field">
                      <label>Venue / Link</label>
                      <input type="text" value={driveForm.venue}
                        onChange={(e) => setDriveForm({ ...driveForm, venue: e.target.value })}
                        placeholder="e.g. Main Auditorium or Zoom link"
                      />
                    </div>
                  </div>
                  <div className="rp-field full">
                    <label>Description</label>
                    <textarea rows="4" value={driveForm.description}
                      onChange={(e) => setDriveForm({ ...driveForm, description: e.target.value })}
                      placeholder="Brief about the company, role, and drive..."
                    />
                  </div>
                  <div className="rp-field full">
                    <label>Tags</label>
                    <div className="rp-tags-input-wrap">
                      {driveForm.tags.map((t) => (
                        <span key={t} className="rp-tag-chip">#{t}<button type="button" onClick={() => removeTag(t)}>×</button></span>
                      ))}
                      <input type="text" value={tagInput}
                        onChange={(e) => setTagInput(e.target.value)}
                        onKeyDown={addTag}
                        placeholder="Type and press Enter..."
                      />
                    </div>
                  </div>
                  <div className="rp-field-row">
                    <div className="rp-field">
                      <label>Status</label>
                      <select value={driveForm.status} onChange={(e) => setDriveForm({ ...driveForm, status: e.target.value })}>
                        {Object.keys(DRIVE_STATUS_CONFIG).map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div className="rp-field">
                      <label>Visibility</label>
                      <div className="rp-check-group">
                        <label className="rp-check-item">
                          <input type="checkbox" checked={driveForm.isPinned}  onChange={(e) => setDriveForm({ ...driveForm, isPinned:  e.target.checked })} />
                          <span className="rp-chk-box"/>
                          <span>📌 Pin to Top</span>
                        </label>
                        <label className="rp-check-item">
                          <input type="checkbox" checked={driveForm.isVisible} onChange={(e) => setDriveForm({ ...driveForm, isVisible: e.target.checked })} />
                          <span className="rp-chk-box"/>
                          <span>🌐 Visible to Students</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="rp-field-row">
                    <div className="rp-field">
                      <label>Total Registered</label>
                      <input type="number" min="0" value={driveForm.totalRegistered}
                        onChange={(e) => setDriveForm({ ...driveForm, totalRegistered: parseInt(e.target.value) || 0 })}
                      />
                    </div>
                    <div className="rp-field">
                      <label>Total Selected</label>
                      <input type="number" min="0" value={driveForm.totalSelected}
                        onChange={(e) => setDriveForm({ ...driveForm, totalSelected: parseInt(e.target.value) || 0 })}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* ── Tab: Eligibility ── */}
              {driveFormTab === "eligibility" && (
                <div className="rp-form-section">
                  <div className="rp-field full">
                    <label>Eligible Branches</label>
                    <div className="rp-branch-checkboxes">
                      {ELIGIBILITY_BRANCHES.map((b) => (
                        <label key={b} className={`rp-branch-check ${driveForm.eligibilityBranches.includes(b) ? "checked" : ""}`}>
                          <input type="checkbox" checked={driveForm.eligibilityBranches.includes(b)} onChange={() => toggleBranch(b)} />
                          {b}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="rp-field-row">
                    <div className="rp-field">
                      <label>Minimum CGPA</label>
                      <input type="text" value={driveForm.minCGPA}
                        onChange={(e) => setDriveForm({ ...driveForm, minCGPA: e.target.value })}
                        placeholder="e.g. 6.5"
                      />
                    </div>
                    <div className="rp-field">
                      <label>Backlog Allowed?</label>
                      <div className="rp-check-group">
                        <label className="rp-check-item">
                          <input type="checkbox" checked={driveForm.backlogAllowed} onChange={(e) => setDriveForm({ ...driveForm, backlogAllowed: e.target.checked })} />
                          <span className="rp-chk-box"/>
                          <span>Yes, backlogs permitted</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ── Tab: Rounds ── */}
              {driveFormTab === "rounds" && (
                <div className="rp-form-section">
                  <div className="rp-field full">
                    <label>Selection Rounds</label>
                    <div className="rp-rounds-builder">
                      {driveForm.rounds.map((r, i) => (
                        <div key={r} className="rp-round-chip">
                          <span className="rp-round-num-sm">{i + 1}</span>
                          <span>{r}</span>
                          <button type="button" onClick={() => removeRound(r)}>×</button>
                        </div>
                      ))}
                      {driveForm.rounds.length === 0 && (
                        <p className="rp-rounds-empty">No rounds added yet. Select from below.</p>
                      )}
                    </div>
                    <div className="rp-rounds-picker">
                      {ROUND_TYPES.filter((r) => !driveForm.rounds.includes(r)).map((r) => (
                        <button key={r} type="button" className="rp-round-add-btn" onClick={() => addRound(r)}>
                          + {r}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="rp-rounds-hint">
                    <span>💡</span>
                    <p>Click a round to add it. The order reflects the selection process sequence. Drag to reorder if needed.</p>
                  </div>
                </div>
              )}

              <div className="rp-form-footer">
                <div className="rp-form-tab-nav">
                  {driveFormTab !== "basic"       && <button type="button" className="rp-btn-light" onClick={() => setDriveFormTab(driveFormTab === "rounds" ? "eligibility" : "basic")}>← Previous</button>}
                  {driveFormTab !== "rounds"      && <button type="button" className="rp-btn-secondary" onClick={() => setDriveFormTab(driveFormTab === "basic" ? "eligibility" : "rounds")}>Next →</button>}
                </div>
                <div className="rp-form-footer-right">
                  <button type="button" className="rp-btn-light" onClick={() => setDriveModal("")}>Cancel</button>
                  <button type="submit" className="rp-btn-primary">
                    {driveModal === "add" ? "✓ Publish Drive" : "✓ Update Drive"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ══════ COMPANY ADD/EDIT MODAL ══════ */}
      {(companyModal === "add" || companyModal === "edit") && (
        <div className="rp-overlay" onClick={() => setCompanyModal("")}>
          <div className="rp-form-modal small" onClick={(e) => e.stopPropagation()}>
            <div className="rp-modal-head">
              <div>
                <h2>{companyModal === "add" ? "Add Company" : "Edit Company"}</h2>
                <p>Manage company profile details.</p>
              </div>
              <button className="rp-modal-close" onClick={() => setCompanyModal("")}>×</button>
            </div>
            <form className="rp-form" onSubmit={saveCompany}>
              <div className="rp-field-row">
                <div className="rp-field">
                  <label>Company Name <span className="req">*</span></label>
                  <input type="text" required value={companyForm.name} onChange={(e) => setCompanyForm({ ...companyForm, name: e.target.value })} placeholder="e.g. Infosys Limited" />
                </div>
                <div className="rp-field">
                  <label>Sector</label>
                  <select value={companyForm.sector} onChange={(e) => setCompanyForm({ ...companyForm, sector: e.target.value })}>
                    {COMPANY_SECTORS.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              <div className="rp-field full">
                <label>Website</label>
                <input type="url" value={companyForm.website} onChange={(e) => setCompanyForm({ ...companyForm, website: e.target.value })} placeholder="https://company.com" />
              </div>
              <div className="rp-field-row">
                <div className="rp-field">
                  <label>Contact Person</label>
                  <input type="text" value={companyForm.contactPerson} onChange={(e) => setCompanyForm({ ...companyForm, contactPerson: e.target.value })} placeholder="HR Manager name" />
                </div>
                <div className="rp-field">
                  <label>Contact Email</label>
                  <input type="email" value={companyForm.contactEmail} onChange={(e) => setCompanyForm({ ...companyForm, contactEmail: e.target.value })} placeholder="hr@company.com" />
                </div>
              </div>
              <div className="rp-field-row">
                <div className="rp-field">
                  <label>Contact Phone</label>
                  <input type="text" value={companyForm.contactPhone} onChange={(e) => setCompanyForm({ ...companyForm, contactPhone: e.target.value })} placeholder="+91 ..." />
                </div>
                <div className="rp-field">
                  <label>Avg. Package Offered</label>
                  <input type="text" value={companyForm.avgPackage} onChange={(e) => setCompanyForm({ ...companyForm, avgPackage: e.target.value })} placeholder="e.g. ₹4.5 LPA" />
                </div>
              </div>
              <div className="rp-field-row">
                <div className="rp-field">
                  <label>Total Students Hired</label>
                  <input type="number" min="0" value={companyForm.totalHires} onChange={(e) => setCompanyForm({ ...companyForm, totalHires: parseInt(e.target.value) || 0 })} />
                </div>
                <div className="rp-field">
                  <label>MoU Signed?</label>
                  <div className="rp-check-group">
                    <label className="rp-check-item">
                      <input type="checkbox" checked={companyForm.isMou} onChange={(e) => setCompanyForm({ ...companyForm, isMou: e.target.checked })} />
                      <span className="rp-chk-box"/><span>🤝 MoU with College</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="rp-field full">
                <label>Company Description</label>
                <textarea rows="3" value={companyForm.description} onChange={(e) => setCompanyForm({ ...companyForm, description: e.target.value })} placeholder="Brief about the company..." />
              </div>
              <div className="rp-form-footer">
                <div/>
                <div className="rp-form-footer-right">
                  <button type="button" className="rp-btn-light" onClick={() => setCompanyModal("")}>Cancel</button>
                  <button type="submit" className="rp-btn-primary">{companyModal === "add" ? "✓ Add Company" : "✓ Update"}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ══════ STATS MODAL ══════ */}
      {statsModal && (
        <div className="rp-overlay" onClick={() => setStatsModal(false)}>
          <div className="rp-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="rp-modal-head">
              <div><h2>Edit Placement Statistics</h2><p>Update the placement figures shown on the portal.</p></div>
              <button className="rp-modal-close" onClick={() => setStatsModal(false)}>×</button>
            </div>
            <form className="rp-form" onSubmit={saveStats}>
              <div className="rp-field full">
                <label>Academic Batch</label>
                <input type="text" value={statsForm.batch} onChange={(e) => setStatsForm({ ...statsForm, batch: e.target.value })} placeholder="e.g. 2024–25" />
              </div>
              <div className="rp-field-row">
                <div className="rp-field"><label>Eligible Students</label><input type="number" min="0" value={statsForm.totalStudentsEligible} onChange={(e) => setStatsForm({ ...statsForm, totalStudentsEligible: parseInt(e.target.value) || 0 })} /></div>
                <div className="rp-field"><label>Registered Students</label><input type="number" min="0" value={statsForm.totalStudentsRegistered} onChange={(e) => setStatsForm({ ...statsForm, totalStudentsRegistered: parseInt(e.target.value) || 0 })} /></div>
              </div>
              <div className="rp-field-row">
                <div className="rp-field"><label>Total Placed</label><input type="number" min="0" value={statsForm.totalPlaced} onChange={(e) => setStatsForm({ ...statsForm, totalPlaced: parseInt(e.target.value) || 0 })} /></div>
                <div className="rp-field"><label>Total Companies</label><input type="number" min="0" value={statsForm.totalCompanies} onChange={(e) => setStatsForm({ ...statsForm, totalCompanies: parseInt(e.target.value) || 0 })} /></div>
              </div>
              <div className="rp-field-row">
                <div className="rp-field"><label>Total Offers</label><input type="number" min="0" value={statsForm.totalOffers} onChange={(e) => setStatsForm({ ...statsForm, totalOffers: parseInt(e.target.value) || 0 })} /></div>
                <div className="rp-field"><label>Placement %</label><input type="text" value={statsForm.placementPercentage} onChange={(e) => setStatsForm({ ...statsForm, placementPercentage: e.target.value })} placeholder="e.g. 62.5%" /></div>
              </div>
              <div className="rp-field-row">
                <div className="rp-field"><label>Highest Package</label><input type="text" value={statsForm.highestPackage} onChange={(e) => setStatsForm({ ...statsForm, highestPackage: e.target.value })} placeholder="e.g. ₹24 LPA" /></div>
                <div className="rp-field"><label>Average Package</label><input type="text" value={statsForm.averagePackage} onChange={(e) => setStatsForm({ ...statsForm, averagePackage: e.target.value })} placeholder="e.g. ₹5.2 LPA" /></div>
              </div>
              <div className="rp-field full"><label>Median Package</label><input type="text" value={statsForm.medianPackage} onChange={(e) => setStatsForm({ ...statsForm, medianPackage: e.target.value })} placeholder="e.g. ₹4.5 LPA" /></div>
              <div className="rp-form-footer">
                <div/>
                <div className="rp-form-footer-right">
                  <button type="button" className="rp-btn-light" onClick={() => setStatsModal(false)}>Cancel</button>
                  <button type="submit" className="rp-btn-primary">✓ Save Statistics</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ══════ SETTINGS MODAL ══════ */}
      {settingsModal && (
        <div className="rp-overlay" onClick={() => setSettingsModal(false)}>
          <div className="rp-form-modal small" onClick={(e) => e.stopPropagation()}>
            <div className="rp-modal-head">
              <div><h2>Edit Portal Settings</h2><p>Configure the recruitment portal.</p></div>
              <button className="rp-modal-close" onClick={() => setSettingsModal(false)}>×</button>
            </div>
            <form className="rp-form" onSubmit={saveSettings}>
              <div className="rp-field full"><label>Portal Title</label><input type="text" value={settingsForm.portalTitle} onChange={(e) => setSettingsForm({ ...settingsForm, portalTitle: e.target.value })} /></div>
              <div className="rp-field full"><label>Subtitle</label><input type="text" value={settingsForm.portalSubtitle} onChange={(e) => setSettingsForm({ ...settingsForm, portalSubtitle: e.target.value })} /></div>
              <div className="rp-field-row">
                <div className="rp-field"><label>Placement Officer Name</label><input type="text" value={settingsForm.placementOfficerName} onChange={(e) => setSettingsForm({ ...settingsForm, placementOfficerName: e.target.value })} /></div>
                <div className="rp-field"><label>Officer Email</label><input type="email" value={settingsForm.placementOfficerEmail} onChange={(e) => setSettingsForm({ ...settingsForm, placementOfficerEmail: e.target.value })} /></div>
              </div>
              <div className="rp-field full"><label>Officer Phone</label><input type="text" value={settingsForm.placementOfficerPhone} onChange={(e) => setSettingsForm({ ...settingsForm, placementOfficerPhone: e.target.value })} /></div>
              <div className="rp-field full"><label>Portal Announcement</label><textarea rows="3" value={settingsForm.portalMessage} onChange={(e) => setSettingsForm({ ...settingsForm, portalMessage: e.target.value })} /></div>
              <div className="rp-settings-checks">
                {[
                  { key: "registrationOpen",     label: "Student Registration Open",    desc: "Allow students to register on the portal."    },
                  { key: "showPackageDetails",    label: "Show Package Details",          desc: "Display CTC/salary details on drive cards."    },
                  { key: "showCompanyContacts",   label: "Show Company Contacts",         desc: "Make HR contact info visible to students."     },
                ].map((item) => (
                  <label key={item.key} className="rp-settings-check-item">
                    <input type="checkbox" checked={settingsForm[item.key]} onChange={(e) => setSettingsForm({ ...settingsForm, [item.key]: e.target.checked })} />
                    <span className="rp-chk-box"/>
                    <div><strong>{item.label}</strong><p>{item.desc}</p></div>
                  </label>
                ))}
              </div>
              <div className="rp-form-footer">
                <div/>
                <div className="rp-form-footer-right">
                  <button type="button" className="rp-btn-light" onClick={() => setSettingsModal(false)}>Cancel</button>
                  <button type="submit" className="rp-btn-primary">✓ Save Settings</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ══════ CONFIRM DELETE ══════ */}
      {confirm.id !== null && (
        <div className="rp-overlay" onClick={() => setConfirm({ type: "", id: null })}>
          <div className="rp-confirm" onClick={(e) => e.stopPropagation()}>
            <div className="rp-confirm-icon">🗑️</div>
            <h3>Delete this {confirm.type === "drive" ? "drive" : "company"}?</h3>
            <p>This action is permanent and cannot be undone.</p>
            <div className="rp-confirm-actions">
              <button className="rp-btn-light" onClick={() => setConfirm({ type: "", id: null })}>Cancel</button>
              <button className="rp-btn-danger" onClick={handleDelete}>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── Drive Card ───────────────────────────────────────────────────────────────
const DriveCard = ({ item, sc, formatDate, isExpired, daysLeft, openView, openDD }) => {
  const s   = sc(item.status);
  const dl  = daysLeft(item.registrationDeadline);
  const exp = isExpired(item.registrationDeadline);

  return (
    <div className={`rp-drive-card ${!item.isVisible ? "hidden-card" : ""} ${item.isPinned ? "pinned-card" : ""}`}>
      <div className="rp-drive-card-head">
        <div className="rp-drive-avatar">{item.companyName.charAt(0)}</div>
        <div className="rp-drive-title">
          <div className="rp-drive-meta-row">
            <span className="rp-sector-pill">{item.sector}</span>
            {item.isPinned    && <span className="rp-badge-sm pin">📌</span>}
            {!item.isVisible  && <span className="rp-badge-sm hidden">🙈</span>}
          </div>
          <h3 onClick={() => openView(item)}>{item.companyName}</h3>
          <p className="rp-drive-sub">{item.jobTitle} · {item.jobType}</p>
        </div>
        <button className="rp-dots" onClick={(e) => openDD(e, "drive", item.id)}>⋮</button>
      </div>

      {(item.packageMin || item.packageMax) && (
        <div className="rp-drive-package">
          💰 {item.packageMin && item.packageMax && item.packageMin !== item.packageMax
            ? `₹${item.packageMin} – ₹${item.packageMax} LPA`
            : `₹${item.packageMin || item.packageMax} LPA`}
        </div>
      )}

      <div className="rp-drive-chips">
        <span>📅 {formatDate(item.driveDate)}</span>
        <span>🖥️ {item.mode}</span>
        <span>👥 {item.totalRegistered} registered</span>
        {item.totalSelected > 0 && <span>✅ {item.totalSelected} selected</span>}
      </div>

      {item.rounds.length > 0 && (
        <div className="rp-rounds-preview">
          {item.rounds.map((r, i) => (
            <span key={r} className="rp-round-tag">
              <span className="rp-round-no">{i + 1}</span>{r}
            </span>
          ))}
        </div>
      )}

      {item.tags.length > 0 && (
        <div className="rp-tag-row">
          {item.tags.slice(0, 3).map((t) => <span key={t} className="rp-tag">#{t}</span>)}
          {item.tags.length > 3 && <span className="rp-tag muted">+{item.tags.length - 3}</span>}
        </div>
      )}

      <div className="rp-drive-footer">
        <div className="rp-drive-footer-left">
          <span className="rp-status-badge"
            style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}` }}>
            <span className="rp-status-dot" style={{ background: s.dot }}/>
            {item.status}
          </span>
          <span className={`rp-deadline-tag ${exp ? "expired" : dl !== null && dl <= 5 ? "urgent" : ""}`}>
            📋 Reg: {exp ? "Closed" : formatDate(item.registrationDeadline)}
            {!exp && dl !== null && dl <= 5 && <span className="rp-days-badge">{dl}d</span>}
          </span>
        </div>
        <button className="rp-view-sm" onClick={() => openView(item)}>Details →</button>
      </div>
    </div>
  );
};

export default RecruitmentPortal;